import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import axios from 'axios'  // 安装axios后引入

Vue.prototype.$axios = axios

Vue.use(Antd)

new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js